/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Menu, MenuItem } from "react-pro-sidebar";
import { Flex } from "antd";
import { CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import logo from "../../assets/images/Logo-AI.png";
import nav from "../../nav";

const COOKIE_KEY = "ais_sidenav_search";

const getCookieValue = (name) => {
  if (typeof document === "undefined") return "";
  const target = document.cookie.split("; ").find((c) => c.startsWith(`${name}=`));
  if (!target) return "";
  return decodeURIComponent(target.split("=").slice(1).join("="));
};

const setCookieValue = (name, value, days = 30) => {
  if (typeof document === "undefined") return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

const Sidenav = () => {
  const [search, setSearch] = useState(() => getCookieValue(COOKIE_KEY));
  const { pathname } = useLocation();

  const navActiveStyle = {
    padding: "10px 16px",
    color: "#141414",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 20px 27px rgba(0,0,0,.05)",
  };

  useEffect(() => {
    setCookieValue(COOKIE_KEY, search);
  }, [search]);

  const filterNav = (navList) =>
    navList.filter(
      (item) =>
        !item.title ||
        item.title.toLowerCase().includes(search.toLowerCase())
    );

  const filteredMenuCount = filterNav(nav).filter((item) => !item?.type).length;

  return (
    <>
      <Flex vertical className="brand width-100" justify='center' align='center'>
        <img src={logo} alt="AI Solution logo" style={{ width: 528, height: 96 }} />
        <span>AI Solution</span>
      </Flex>
      <hr />

      <div
        style={{
          width: "calc(100% - 20px)",
          margin: "0 auto 14px",
          padding: "10px",
          borderRadius: 14,
          background: "linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)",
          border: "1px solid #d8e7ff",
          boxShadow: "0 10px 24px rgba(64, 103, 173, 0.08)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 8,
            paddingInline: 2,
          }}
        >
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 0.4,
              textTransform: "uppercase",
              color: "#4a6ea8",
            }}
          >
            Menu Search
          </span>
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: search ? "#2f5fb3" : "#7e90ad",
            }}
          >
            {filteredMenuCount} รายการ
          </span>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 12px",
            borderRadius: 12,
            backgroundColor: "#ffffff",
            border: search ? "1px solid #7aa7ff" : "1px solid #d7dfeb",
            boxShadow: search
              ? "0 0 0 4px rgba(91, 141, 239, 0.16)"
              : "inset 0 1px 2px rgba(15, 23, 42, 0.04)",
            transition: "all 0.2s ease",
          }}
        >
          <SearchOutlined style={{ fontSize: 16, color: search ? "#2f5fb3" : "#8a94a6" }} />
          <input
            type="text"
            placeholder="ค้นหาเมนู..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              flex: 1,
              minWidth: 0,
              border: "none",
              outline: "none",
              background: "transparent",
              fontSize: 14,
              fontWeight: 500,
              color: "#1f2937",
            }}
          />
          {search ? (
            <button
              type="button"
              onClick={() => setSearch("")}
              aria-label="ล้างข้อความค้นหา"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 22,
                height: 22,
                padding: 0,
                border: "none",
                background: "transparent",
                color: "#8a94a6",
                cursor: "pointer",
              }}
            >
              <CloseCircleFilled style={{ fontSize: 16 }} />
            </button>
          ) : null}
        </div>
      </div>

      <Menu theme="light" mode="inline">
        {filterNav(nav).map((item, idx) =>
          !item?.type ? (
            <MenuItem
              icon={item?.icon}
              key={idx}
              component={<Link to={item?.to} style={{ navActiveStyle }} />}
              className={pathname.startsWith(item?.to) ? "nav-active" : null}
            >
              <span>{item?.title}</span>
            </MenuItem>
          ) : (
            <MenuItem type="primary" danger key={idx} className="nav-group-title">
              {item?.title}
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
};

export default Sidenav;
